<template>
    <a :href="regionRelativeUrl(NuxtRoutes.PRODUCTS.BUY_PREMIUM)" class="btn btn-gold w-100 cursor-pointer">
        <span>{{ translate.account.lockedProfile.upgradeToGold }}</span>
        <icon-component class="ml-2 h-100 upgrade-gold-icon" :icon="fa_stars_regular()"></icon-component>
    </a>
</template>

<script>
import {fa_stars_regular} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";

export default {
    components: {IconComponent},
    data() {
        return {
            NuxtRoutes,
        };
    },
    methods: {fa_stars_regular},
    mixins: [regionsUrlMixin],
    computed: {
        ...mapState(['translate']),
    },
};
</script>
